(function($) {

$(document).ready(function() {
  // clicking on see all will reveal all sections
  $('.search-filter .clearFilter').on('click', function() {
    $(this).addClass('current').siblings().removeClass('current');
    clearFilter();
  })
  //click a sort function will sort visible listings
  $('.search-filter span:not(.current)').on('click', function(){
    $(this).addClass('current').siblings().removeClass('current');
    filterSearch($(this));
  })

  $('.search-mobile-trigger').on('click', function(e) {
    var filter = $(this).find('.search-filter--dropdown');

    if (!$(e.target).hasClass('topLink')) {
      e.preventDefault();
      return false;
    }

    if (!filter.hasClass('is-open')) {
      filter.css('display','none').addClass('is-open').css('transition','0ms').slideDown(400,function(){ $(filter).css('transition',''); });
      console.log('open');

    } else {
      filter.removeClass('is-open').slideUp(400);
      filter.find('span.current').removeClass('current');
      clearFilter();
      console.log('close');
    }
  });

  // loading the page with a selection chosen
  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    console.log('doot1');
    if ($('#js-search-'+hash).length) {
      console.log('doot2');
      $('.search-filter span[data-type="'+hash+'"]').trigger('click');
    }
  }
})

function clearFilter() {
  if ($('.hv-search__section').hasClass('hide')) {
    $('.hv-search__section').removeClass('hide');
  }
}

function filterSearch(filterItem) {
  var sectionType = $(filterItem).attr('data-type');

  var targetSection = '#js-search-' + sectionType;

  if ($(targetSection).length){
    if ($(targetSection).hasClass('hide')) $(targetSection).removeClass('hide');

    $(targetSection).addClass('active').siblings('.hv-search__section').addClass('hide');
  } else {
    $('.hv-search__section').addClass('hide');
  }

}

})( jQuery );
